<template>
  <form enctype="multipart/form-data" @submit.prevent="submit(form)">
    <div class="flex flex-wrap p-8 mb-8 -mr-6">
      <div class="w-full pb-8 pr-6 lg:w-1/1">
        <label class="form-label">{{ __('Categories') }}</label>

        <VueMultiselect
          v-model="selectedCategories"
          group-label="name"
          track-by="id"
          label="name"
          :options="categories"
          :multiple="true"
          :group-select="true"
          :placeholder="__('Type to search')"
        />

        <div v-if="form.errors.categories_ids" class="form-error">
          {{ form.errors.categories_ids }}
        </div>
      </div>

      <TextInput
        v-model="form.name"
        class="w-full pb-8 pr-6 lg:w-1/2"
        :error="form.errors.name"
        :label="__('Name')"
      />

      <TextInput
        v-model="form.article_name"
        class="w-full pb-8 pr-6 lg:w-1/2"
        :error="form.errors.article_name"
        :label="__('Article Name')"
      />

      <div class="w-full pb-8 pr-6 lg:w-1/2">
        <label class="form-label">{{ (__('Company')) }}</label>

        <VueMultiselect
          v-model="selectedCompany"
          :options="companies"
            :close-on-select="true"
          :clear-on-select="false"
          placeholder="Select one"
          label="name"
          track-by="id"
          @select="onCompanyChange"
          @remove="onCompanyRemove"
        />

        <div v-if="form.errors.company_id" class="form-error">
          {{ form.errors.company_id }}
        </div>
      </div>

      <TextInput
        v-model="form.gcma"
        :error="form.errors.gcma"
        class="w-full pb-8 pr-6 lg:w-1/2"
        :label="__('GCMA')"
      />

      <div class="flex items-end justify-between w-full">
        <div class="flex w-1/2">
          <CheckboxInput
            v-model="form.available_for_order"
            class="w-full pb-8 pr-6 leading-[25px]"
            :error="form.errors.available_for_order"
            :label="__('Available for order')"
          />

          <CheckboxInput
            v-model="form.attribute_new"
            class="w-full pb-8 pr-6 leading-[25px]"
            :error="form.errors.attribute_new"
            :label="__('Is New')"
          />

          <CheckboxInput
            v-model="form.is_published"
            class="w-full pb-8 pr-6 leading-[25px]"
            :error="form.errors.is_published"
            :label="__('Is Published')"
          />
        </div>

        <div class="flex items-end w-1/2">
          <TextInput
            v-model="form.sort_order"
            type="number"
            class="w-full pb-8 pr-6"
            :error="form.errors.sort_order"
            :label="__('Sort Order')"
            :sublabel="__('Lägst tal kommer först. Negativa tal är tillåtna och 0 betyder ej sorterad')"
          />

          <TextInput
            v-model="form.max_per_order"
            type="number"
            class="w-full pb-8 pr-6"
            :error="form.errors.max_per_order"
            :label="__('Max antal per beställning')"
            :sublabel="__('Ange 0 för ett obegränsat antal')"
          />
        </div>
      </div>

      <TextInput
        v-model="form.info_text"
        class="w-full pb-8 pr-6"
        :error="form.errors.info_text"
        :label="__('Info Text')"
      />

      <div class="w-full pb-8 pr-6 lg:w-1/2">
        <label class="form-label">{{ __('Receivers') }}</label>

        <VueMultiselect
          v-model="form.receivers"
          :class="{ error: form.errors.receivers }"
          :options="form.receiver_list"
          :multiple="true"
          :taggable="true"
          :close-on-select="false"
          :tag-placeholder="__('Add this as new receiver')"
          :placeholder="__('Type to search or add receiver')"
          @tag="addReceiver"
        />

        <div v-if="Object.keys(form.errors).toString().includes('receivers')" class="form-error">
          {{ __('The receivers must be a valid email address') }}
        </div>
      </div>

      <div class="w-full pb-8 pr-6 lg:w-1/2">
        <label class="form-label">{{ (__('Target group filter')) }}</label>

        <VueMultiselect
          v-model="selectedTargetGroups"
          :options="targetGroups"
          :close-on-select="true"
          :clear-on-select="false"
          placeholder="Select one"
          label="name"
          track-by="id"
          @select="onTargetGroupSelect"
          @remove="onTargetGroupRemove"
        />

        <div v-if="form.errors.target_group" class="form-error">
          {{ form.errors.target_group }}
        </div>
      </div>

      <div class="flex justify-between w-full">
        <div class="flex w-full mb-[30px]">
          <FileInput v-if="(!previewImage1 && !previewImage1Url) || form.errors.image1_file"
            v-model="this.form.image1_file"
            type="file"
            class="w-full pt-6 pb-8 pr-6"
            accept="image/*"
            :error="form.errors.image1_file"
            :label="__('Image')"
                        @update:previewImage1="onImageChange(1)"
          />

          <div v-if="previewImage1 || previewImage1Url" class="flex flex-col">
            <h3 class="mb-[5px]">Bild</h3>


            <div v-if="previewImage1Url">
                <img
                  :src="previewImage1Url"
                  class="max-w-[150px]"
                />
            </div>
            <div v-else :style="{ 'background-image': `url(${previewImage1})` }" class="w-[150px] h-[150px] bg-center bg-contain bg-no-repeat">
            </div>

            <span
              class="btn cursor-pointer mt-[15px] text-red-600 hover:underline text-[14px]"
              @click="resetImage(1)"
            >
              Ta bort bild
            </span>
          </div>
        </div>
        <div class="flex w-full mb-[30px]">
          <FileInput v-if="(!previewImage2 && !previewImage2Url) || form.errors.image2_file"
            v-model="this.form.image2_file"
            type="file"
            class="w-full pt-6 pb-8 pr-6"
            accept="image/*"
            :error="form.errors.image2_file"
            :label="__('Image')"
                        @update:previewImage2="onImageChange(2) "
          />

          <div v-if="previewImage2 || previewImage2Url" class="flex flex-col">
            <h3 class="mb-[5px]">Bild</h3>


            <div v-if="previewImage2Url">
                <img
                  :src="previewImage2Url"
                  class="max-w-[150px]"
                />
            </div>
            <div v-else :style="{ 'background-image': `url(${previewImage2})` }" class="w-[150px] h-[150px] bg-center bg-contain bg-no-repeat">
            </div>

            <span
              class="btn cursor-pointer mt-[15px] text-red-600 hover:underline text-[14px]"
              @click="resetImage(2)"
            >
              Ta bort bild
            </span>
          </div>
        </div>
        <div class="flex w-full mb-[30px]">
          <FileInput v-if="(!previewImage3 && !previewImage3Url) || form.errors.image3_file"
            v-model="this.form.image3_file"
            type="file"
            class="w-full pt-6 pb-8 pr-6"
            accept="image/*"
            :error="form.errors.image3_file"
            :label="__('Image')"
                        @update:previewImage3="onImageChange(3)"
          />

          <div v-if="previewImage3 || previewImage3Url" class="flex flex-col">
            <h3 class="mb-[5px]">Bild</h3>


            <div v-if="previewImage3Url">
                <img
                  :src="previewImage3Url"
                  class="max-w-[150px]"
                />
            </div>
            <div v-else :style="{ 'background-image': `url(${previewImage3})` }" class="w-[150px] h-[150px] bg-center bg-contain bg-no-repeat">
            </div>

            <span
              class="btn cursor-pointer mt-[15px] text-red-600 hover:underline text-[14px]"
              @click="resetImage(3)"
            >
              Ta bort bild
            </span>
          </div>
        </div>
        <div class="flex w-full mb-[30px] justify-between">
          <FileInput
            v-if="!form.attachment || form.errors.attachment_file"
            v-model="form.attachment_file"
            type="file"
            class="w-full pt-6 pb-8 pr-6"
            accept="application/pdf"
            :error="form.errors.attachment_file"
            :label="__('Attachment')"
          />

          <div v-else-if="form.attachment" class="flex flex-col">
            <h3 class="mb-[5px]">Bilaga</h3>

            <span class="mt-[20px] text-[14px]"><a :href="`/storage/${form.attachment.path}`">{{form.attachment.name}}</a></span>

            <span
              class="btn cursor-pointer mt-[15px] text-red-600 hover:underline text-[14px]"
              @click="resetFile"
            >
              Ta bort billaga
            </span>
          </div>
        </div>
      </div>
      <div class="w-full pb-8 pr-6 lg:w-1/1">
        <TextInput
            v-model="form.external_document_link"
            type="text"
            class="w-full"
            :error="form.errors.external_document_link"
            :label="__('URL till nedladdningsbart dokument')"
            :sublabel="__('Använd detta fält om du vill länka till ett dokument som ligger på en annan webbplats')"
          />
      </div>

      <div class="w-full pb-10 pr-6 lg:w-1/1">
        <label class="form-label">{{ __('Description') }}</label>

        <QuillEditor
          v-model:content="form.description"
          ref="description"
          content-type="html"
          class="pt-6 pb-4"
          label="Description"
          :error="form.errors.description"
          :placeholder="__('Type description here…')"
          :options="editorOption"
        />

        <div v-if="form.errors.description" class="pt-6 form-error">
          {{ form.errors.description }}
        </div>
      </div>
    </div>

    <div class="flex items-center justify-between pt-6 px-8 py-4 border-t border-gray-100 bg-gray-50">
      <button v-if="form.id" class="text-red-600 hover:underline" tabindex="-1" type="button" @click="destroy">
        {{ __('Delete') }}
      </button>

      <LoadingButton :loading="form.processing" class="btn-save" type="submit">
        {{ __(label) }}
      </LoadingButton>
    </div>
  </form>
</template>

<script>
  import VueMultiselect  from 'vue-multiselect'
  import { QuillEditor } from '@vueup/vue-quill'
  import TextInput 	   from '@/Shared/TextInput'
  import CheckboxInput   from '@/Shared/CheckboxInput'
  import LoadingButton   from '@/Shared/LoadingButton'
  import FileInput 	   from '@/Shared/FileInput'
  import { useForm }     from '@inertiajs/inertia-vue3'
  import '@vueup/vue-quill/dist/vue-quill.snow.css'

  export default {
    components: {
      VueMultiselect,
      QuillEditor,
      TextInput,
      CheckboxInput,
      FileInput,
      LoadingButton,
    },
    props: {
      model: {
        type: Object,
        default: () => ({
          name: null,
          article_name: null,
          description: null,
          gcma: null,
          info_text: null,
          sort_order: 0,
          max_per_order: 0,
          available_for_order: 0,
          attribute_new: 0,
          image1_file: null,
          image2_file: null,
          image3_file: null,
          attachment_file: null,
          external_document_link: null,
          categories_ids: [],
          company_id: null,
          receiver_list: [],
          receivers: [],
          is_published: 0,
          target_group: null,
        })
      },
      submit: {
        type: Function,
        default: () => {}
      },
      label: {
        type: String,
        default: () => { return 'Create Product' }
      }
    },
    remember: 'form',
    data() {
      return {
        previewImage1Url: null,
        previewImage1: null,
        previewImage2Url: null,
        previewImage2: null,
        previewImage3Url: null,
        previewImage3: null,
        categories: [],
        companies: [],
        receivers: [],
        targetGroups: [ // @REFACTOR: get this from  backend? id is the DB id for filters table
          { id: 1, name: 'Till patient', value: 'patient' },
          { id: 2, name: 'Till dig inom vården', value: 'medical' },
        ],
        selectedCategories: [],
        selectedCompany: null,
        selectedTargetGroups: [],
        form: useForm(this.model),
          editorOption: {
          placeholder: 'Enter content here...',
          readOnly: false,
          theme: 'snow',
              modules: {
                toolbar: {
                container: [
                [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
                ['bold', 'italic', 'underline', 'link']
              ]
            }
          }
        }
      }
    },
    watch: {
      selectedCategories: {
        deep: true,
        handler() {
          this.form.categories_ids = this.selectedCategories.map((category) => category.id)
        }
      },
      form: {
        deep: true,
        immediate: true,
        handler() {
          if (this.form.image1_url) {
            this.previewImage1Url = this.form.image1_url
          }

          if (this.form.image2_url) {
            this.previewImage2Url = this.form.image2_url
          }

          if (this.form.image3_url) {
            this.previewImage3Url = this.form.image3_url
          }

          if (this.form.receivers.includes('')) {
            this.form.receivers = this.form.receivers.filter(el => el !== '')
          }
        }
      }
    },
    methods: {
      validEmail(email) {
        const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        return re.test(String(email).toLowerCase())
      },
      onCompanyChange(selectedCompany) {
        this.form.company_id = selectedCompany.id
      },
      onTargetGroupSelect(selectedTargetGroup) {
        this.form.target_group = selectedTargetGroup.id
      },
      onImageChange(image, number) {
                this['previewImage'+number] = image
                this['previewImage'+number+'Url'] = null
      },
      onCompanyRemove() {
        this.form.company_id = null
      },
      onTargetGroupRemove() {
        this.form.target_group = null
      },
      addReceiver(newReceiver) {
        if (this.receivers.find((option) => option === newReceiver)) {
          return
        }

        if (!this.validEmail(newReceiver)) {
          alert(this.__('Invalid email address'))
          return
        }

        this.receivers.push(newReceiver)
        this.form.receivers.push(newReceiver)
      },
      fetchCompanies() {
        fetch('/api/companies').then((response) => response.json()).then((data) => {
          this.companies = data.data

          if (this.form.company_id) {
            this.selectedCompany = this.companies.find((company) => company.id === this.form.company_id)
          }
        })
      },
      fetchCategories() {
        fetch('/api/categories?per_page=all').then((response) => response.json()).then((data) => {
          this.categories = data.categories

          this.selectedCategories = this.form.categories_ids.map((id) =>
            this.categories.find((category) => category.id === id))
          })
      },
      destroy() {
        if (confirm(this.__('Are you sure you want to delete this product?'))) {
          this.$inertia.delete(`/products/${this.form.id}`)
        }
      },
      resetImage(number) {
        this.form['image'+number+'_url']  = null
        this.form['image'+number+'_file'] = null
        this['previewImage'+number] 	    = null
        this['previewImage'+number+'Url'] = null
      },
      resetFile() {
        this.form.attachment = null
      }
    },
    mounted() {
      this.fetchCategories()
      this.fetchCompanies()
      if (this.form.target_group) {
          this.selectedTargetGroups = this.targetGroups.find((targetGroup) => this.form.target_group == targetGroup.id)
          this.form.target_group = this?.selectedTargetGroups?.id
      }
    }
  }
</script>

<style src="vue-multiselect/dist/vue-multiselect.css"></style>
